/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseUpdateRequest} from '../models/LicenseUpdateRequest';

export interface SaveLicenseBaseInfo$Request {
    accountId: number;
    licenseUpdateRequest: LicenseUpdateRequest;
}

export interface SaveLicenseBaseInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveLicenseBaseInfoRequest = createAction<PayloadData<void, SaveLicenseBaseInfo$Request>>('SAVE_LICENSE_BASE_INFO__SAVE_LICENSE_BASE_INFO__REQUEST');
export const saveLicenseBaseInfoSuccess = createAction<PayloadData<number, SaveLicenseBaseInfo$Request>>('SAVE_LICENSE_BASE_INFO__SAVE_LICENSE_BASE_INFO__SUCCESS');
export const saveLicenseBaseInfoFailure = createAction<PayloadData<Error, SaveLicenseBaseInfo$Request, true>>('SAVE_LICENSE_BASE_INFO__SAVE_LICENSE_BASE_INFO__FAILURE');

export const saveLicenseBaseInfoActions = [
    saveLicenseBaseInfoRequest,
    saveLicenseBaseInfoSuccess,
    saveLicenseBaseInfoFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {LicenseUpdateRequest} meta.licenseUpdateRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveLicenseBaseInfo = (meta: SaveLicenseBaseInfo$Request, config?: SaveLicenseBaseInfo$Config) => {
    return {
        CALL_API: {
            types: saveLicenseBaseInfoActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/licenses/base-info`,
            TRANSPORT_REQUEST_BODY: meta.licenseUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

